module.exports = __webpack_public_path__ + "assets/img/foot-logo.88758092.png";